/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useEffect } from 'react'
import { ListView } from 'antd-mobile'
import PageLoading from '@components/PageLoading'
import { observer } from 'mobx-react'

import { AssetsRecordSource } from '@store/bankStore'
import { formatNumber } from '@utils/utils'
import { isMobile } from 'react-device-detect'
import { AdvEmpty } from '@components/AdvEmpty'
import { EMPTY_ICON } from '@constants/index'
// icon
// css
import { TxtLimit } from '@styles/base.style'
import { PROPERTY_ID } from 'adv-protocol/src/GameCommon'
import useRootStore from '@store/useRootStore'
import { useOnMount } from '@utils/reactExt'
import { Schema$RecordUserAsset, Schema$RecordUserMoney } from '@protocol/bank'
import { getIconByPropertyId } from '@utils/jsxutils'

import { MoneyHistoryWrap, MoneyStyle } from '../index.style'
import MoneyHistoryListItem from '../MoneyHistoryListItem'


const dataSource = new ListView.DataSource({
  rowHasChanged: (row1, row2) => {
    return row1 !== row2
  },
})

const PAGE_SIZE = 20

function MyBody(props: any) {
  const { children } = props
  return <div className="am-list-body my-body">{children}</div>
}

const MoneyHistoryList: React.FC = () => {
  const { authStore, bankStore } = useRootStore()
  const { currentMyBankPropertyId, isLoading, historyList = {} as AssetsRecordSource } = bankStore
  const { tracks = [] } = historyList
  const { money, heart, cash } = authStore.userInfo

  useOnMount(() => {
    // bankStore.fetchHistoryList(PAGE_SIZE, true)
  })

  useEffect(() => {
    if (currentMyBankPropertyId) {
      bankStore.fetchHistoryList(PAGE_SIZE, true)
    }
  }, [currentMyBankPropertyId])

  const onEndReached = async event => {
    bankStore.fetchHistoryList(PAGE_SIZE, false)
  }

  const renderRow = (rowDataList: Schema$RecordUserAsset | Schema$RecordUserMoney) => {
    return <MoneyHistoryListItem propertyId={currentMyBankPropertyId} track={rowDataList}/>
  }

  const renderFooter = () => {
    let footer
    if (isLoading) {
      footer = <PageLoading/>
    } else if (tracks.length > 0) {
      footer = <Fragment/>
    } else {
      footer = <AdvEmpty ico={EMPTY_ICON.MONEY_HISTORY}/>
    }
    return <div css={{ textAlign: 'center' }}>{footer}</div>
  }

  const renderTitle = (): React.ReactElement => {
    let propertyValue: string | number
    let title
    switch (currentMyBankPropertyId) {
      case PROPERTY_ID.MONEY:
        title = '보유 G머니'
        propertyValue = money
        break
      case PROPERTY_ID.HEART:
        title = '보유 하트'
        propertyValue = heart
        break
      case PROPERTY_ID.CASH:
        title = '보유 S캐시'
        propertyValue = cash
        break
    }
    if (title) {
      return (
        <div className="money-row">
          <span className="money-row--txt">{title}</span>
          <span className="money-row--money-wrap">
              <span className="money-row--money-wrap--num" css={TxtLimit}>{formatNumber(propertyValue)}</span>
              <MoneyStyle>{getIconByPropertyId(currentMyBankPropertyId)}</MoneyStyle>
            </span>
        </div>
      )
    }
    return null
  }

  const listViewProps = {
    css: { height: 'calc(100% - 78px)' },
    dataSource: dataSource.cloneWithRows(tracks),
    renderFooter,
    renderRow,
    className: 'am-list',
    pageSize: PAGE_SIZE,
    useBodyScroll: isMobile,
    renderBodyComponent: () => <MyBody/>,
    scrollRenderAheadDistance: 500,
    initialListSize: 20,
    onEndReached,
    onEndReachedThreshold: 10,
  }

  if (isMobile) {
    delete listViewProps.renderBodyComponent
  }

  return (
    <MoneyHistoryWrap className={!isMobile && 'pc-money-history-wrap'}>
      {renderTitle()}
      <ListView {...listViewProps} />
    </MoneyHistoryWrap>
  )
}

export default observer(MoneyHistoryList)
